export type LowCreditsNoticeCta = {
  hrefSuffix: 'purchase' | 'usage' | 'billing';
  intent: 'subscribe' | 'check-usage' | 'add-credits';
};

/**
 * Resolve the primary CTA for the workspace low-credits notice.
 * Free / zero-credit workspaces should be nudged toward purchase/subscribe
 * rather than usage analytics.
 */
export function resolveLowCreditsNoticeCta(args: {
  billingPlan?: string | null;
  creditStatus?: 'healthy' | 'low' | 'critical' | 'insufficient' | null;
  balance?: number | null;
}): LowCreditsNoticeCta {
  const isFree = args.billingPlan === 'free';
  const isInsufficient =
    args.creditStatus === 'insufficient' ||
    (typeof args.balance === 'number' && args.balance <= 0);

  if (isFree && isInsufficient) {
    return { hrefSuffix: 'purchase', intent: 'subscribe' };
  }

  if (isInsufficient) {
    return { hrefSuffix: 'billing', intent: 'add-credits' };
  }

  return { hrefSuffix: 'usage', intent: 'check-usage' };
}

export function buildLowCreditsNoticeHref(
  orgSlug: string,
  cta: LowCreditsNoticeCta
): string {
  return `/${orgSlug}/settings/${cta.hrefSuffix}`;
}
